import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative border-b-[3px] border-gold bg-gradient-to-b from-[#1a0000] via-black to-surface-dark px-6 py-10 md:px-20 md:py-[60px] pb-[50px] overflow-hidden min-h-[85vh] flex flex-col justify-center" data-id="element-53">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-54">
        <div className="absolute inset-0 bg-gradient-to-b from-[#1a0000]/90 via-black/95 to-surface-dark z-10" data-id="element-55" />
        <img src="https://cdn.magicpatterns.com/uploads/bhbAZVydAEcDj1CTF6wiir/Imagen_Codigo_de_identidad-6.png" alt="Hombre analizando el código de identidad" className="w-full h-full object-cover object-top opacity-30 grayscale" data-id="element-56" />
      </div>

      {/* Radial gold glow behind title */}
      <div className="absolute inset-0 z-[1] flex items-center justify-center pointer-events-none" data-id="element-57">
        <div className="w-[600px] h-[400px] md:w-[900px] md:h-[500px] rounded-full bg-[radial-gradient(ellipse_at_center,rgba(245,200,66,0.12)_0%,rgba(245,200,66,0.04)_40%,transparent_70%)]" data-id="element-58" />
      </div>

      <div className="relative z-20 max-w-[1100px] mx-auto w-full flex flex-col items-center text-center" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-center" data-id="element-60">
          <div className="mb-5 flex flex-col items-center gap-2" data-id="element-61">
            <div className="flex items-center gap-2.5" data-id="element-62">
              <div className="rounded-sm bg-gold px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-63">
                SISTEMA RMA
              </div>
              <div className="text-[11px] tracking-[2px] text-text-ultramuted uppercase font-bold" data-id="element-64">
                ⏱ 48 Horas · Nivel: Avanzado
              </div>
            </div>
            {/* Subtle gold light line under badge */}
            <div className="h-[1px] w-24 bg-gradient-to-r from-transparent via-gold/60 to-transparent" data-id="element-65" />
          </div>

          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-gold uppercase" data-id="element-66">
            <span className="inline-block h-[2px] w-5 bg-gold" data-id="element-67"></span>
            LA CIRUGÍA AUDITIVA Y MENTAL PARA ANIQUILAR EL VIRUS INVISIBLE QUE
            BLOQUEA TU RIQUEZA
          </div>

          <h1 className="mb-6 font-heading text-5xl md:text-[64px] lg:text-[80px] font-black leading-[1.05] uppercase tracking-tight" data-id="element-68">
            <span className="text-white" data-id="element-69">EL CÓDIGO DE </span>
            <br className="hidden md:block" data-id="element-70" />
            <span className="bg-gradient-to-r from-[#f7d673] via-[#F5C842] to-[#d4a720] bg-clip-text text-transparent drop-shadow-[0_0_30px_rgba(245,200,66,0.3)]" data-id="element-71">
              IDENTIDAD 1.0
            </span>
          </h1>

          <div className="mb-10 max-w-[750px] flex flex-col items-center gap-4" data-id="element-72">
            <div className="flex flex-col md:flex-row items-center gap-3 md:gap-5" data-id="element-73">
              <div className="flex items-center gap-2.5 rounded-lg border border-border bg-surface px-4 py-3" data-id="element-74">
                <span className="text-[20px]" data-id="element-75">🧠</span>
                <span className="text-[13px] md:text-[14px] font-bold text-white tracking-[0.5px]" data-id="element-76">
                  Extrae el paradigma subconsciente
                </span>
              </div>
              <span className="hidden md:block text-gold font-black text-[18px]" data-id="element-77">
                →
              </span>
              <div className="flex items-center gap-2.5 rounded-lg border border-border bg-surface px-4 py-3" data-id="element-78">
                <span className="text-[20px]" data-id="element-79">🌡️</span>
                <span className="text-[13px] md:text-[14px] font-bold text-white tracking-[0.5px]" data-id="element-80">
                  Resetea tu termostato financiero
                </span>
              </div>
              <span className="hidden md:block text-gold font-black text-[18px]" data-id="element-81">
                →
              </span>
              <div className="flex items-center gap-2.5 rounded-lg border border-gold/30 bg-gold/10 px-4 py-3" data-id="element-82">
                <span className="text-[20px]" data-id="element-83">💰</span>
                <span className="text-[13px] md:text-[14px] font-bold text-gold tracking-[0.5px]" data-id="element-84">
                  Deja de empujar la pared invisible
                </span>
              </div>
            </div>
            <div className="rounded-sm bg-gold px-4 py-1.5 font-heading text-[10px] font-black tracking-[3px] text-black uppercase" data-id="element-85">
              ⏱ En solo 48 horas
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: 'easeOut'
      }} className="w-full flex flex-col items-center" data-id="element-86">
          <div className="rounded-full animate-gold-pulse" data-id="element-87">
            <CTAButton data-id="element-88" />
          </div>

          <div className="mt-8 flex flex-col md:flex-row gap-4 md:gap-6 justify-center" data-id="element-89">
            <div className="flex items-center gap-2 text-[12px] text-[#555] font-bold uppercase tracking-[1px]" data-id="element-90">
              <div className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-91"></div>
              Reprogramación Subconsciente
            </div>
            <div className="flex items-center gap-2 text-[12px] text-[#555] font-bold uppercase tracking-[1px]" data-id="element-92">
              <div className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-93"></div>
              Resultados en 7 días
            </div>
            <div className="flex items-center gap-2 text-[12px] text-[#555] font-bold uppercase tracking-[1px]" data-id="element-94">
              <div className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-95"></div>
              Acceso Inmediato
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}